
<template>
     <div class="animated fadeIn">
    <loader :show="enviando"/>
    <b-row>
      <b-col sm="12" md="12">
    
    <b-card>
    <b-col md="12" class="text-left">
        <b-button  @click="regresar()" size="sm" variant="secondary"> Regresar a cuentas  </b-button>
    </b-col>
    <b-row v-if="cuenta">
      
      <b-col  sm="12"> <h4 style="text-align: center">Cuenta {{cuenta.noCuenta}}</h4> </b-col>
       
      <b-col md="10">
        <b-form-group >
          <label>Razón social</label>
          <b-form-input disabled v-model="cuenta.razonSocial"></b-form-input>         
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group >
          <label>Metros</label>
          <b-form-input disabled v-model="cuenta.metros"></b-form-input>         
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group >
          <label>Código Postal</label>
           <b-form-input disabled v-model="cuenta.cp"></b-form-input>         
        </b-form-group>
      </b-col>
     
      <b-col md="4">
        <b-form-group >
          <label>Colonia</label>
          <b-form-input disabled v-model="cuenta.colonia"></b-form-input>         
        </b-form-group>
      </b-col>
       <b-col md="4">
        <b-form-group >
          <label>Delegación</label>
           <b-form-input disabled v-model="cuenta.delegacion"></b-form-input>         
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group >
          <label>Domicilio</label>
          <b-form-input disabled v-model="cuenta.domicilio"></b-form-input>         
        </b-form-group>
      </b-col>
     
       
      <b-col md="6">
        <b-form-group >
          <label >Giro</label>
           <b-form-input disabled v-model="cuenta.giro"></b-form-input>         
        </b-form-group>
      </b-col>
       <b-col md="4">
        <b-form-group >
          <label >Nombre de contacto</label>
          <b-form-input disabled v-model="cuenta.nombreContacto"></b-form-input>         
        </b-form-group>
      </b-col>
       <b-col md="4">
        <b-form-group >
          <label >Correo</label>
           <b-form-input disabled v-model="cuenta.correo"></b-form-input>         
         
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group >
          <label >Telefono de contacto</label>
         <b-form-input disabled v-model="cuenta.telefono"></b-form-input>         
        </b-form-group>
      </b-col>
       <b-col md="12">
        <b-form-group >
          <label >Usuario que capturó</label>
         <b-form-input disabled v-model="cuenta.usuarioCaptura"></b-form-input>         
        </b-form-group>
      </b-col>
      
    </b-row>   
    </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import axios from "axios";
import Loader from "../Loader";
import { mapGetters } from "vuex";

export default {
  name: "acta-view",
  components: { Loader },

  computed: {
    ...mapGetters(["httpURL", "sessionToken", "permisos", "role"]),
    
  },
 
  data: function() {
    return {
      enviando: false,
      cuenta:null,
    };
  },
  
  created(){
    if( this.role != 'administrador' && this.permisos.findIndex(x => x.numero == 224) == -1) this.$router.go(-1)
    this.enviando = true;
    axios.get(this.httpURL+'/proteccionBomberos/cuenta/'+this.$route.params.id,
                {headers:{token:this.sessionToken}})
        .then(res => {
            //console.log(res.data);
            this.cuenta={
              metros:res.data.cuenta.metros,
                noCuenta: res.data.cuenta.folio,
                razonSocial:res.data.cuenta.razonSocial,
                cp:res.data.cuenta.cp,
                domicilio:res.data.cuenta.domicilio,
                colonia:res.data.cuenta.colonia,
                delegacion:res.data.cuenta.delegacion,
                giro:res.data.cuenta.giro,
                telefono:res.data.cuenta.telefono,
                nombreContacto:res.data.cuenta.nombreContacto,
                correo:res.data.cuenta.correo,
                usuarioCaptura:res.data.cuenta.usuarioCaptura.nombre+' '+res.data.cuenta.usuarioCaptura.paterno+' '+res.data.cuenta.usuarioCaptura.materno,
                
            },           
            this.enviando = false;
        })
        .catch(error => {
          this.enviando = false;
          //console.log(error);
           swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
           this.enviando = false;
        });
    
  },
  
  methods: {
      regresar(){
         this.$router.replace({path: '/proteccionBomberos/cuentas'});
      }
     
  }
};
</script>

<style >
.error-text {
  color: #ff0000;
}
.invalid_input{
    border: 1px solid red;
}

</style>